export enum SoulfileApiErrorTypes {
  CreateSoulfileProjectError,
  CreateSoulfileProjectConflictError,
  UpdateSoulfileProjectError,
  UpdateSoulfileProjectConflictError,
  DeleteSoulfileProjectError,
  LoadSoulfileProjectsError,
  LoadSoulfileProjectsCsvError,
  LoadSoulfilesError,
  SoulfileNotFoundError,
  SoulfileProjectNotFoundError,
  CreateSoulfileError,
}

export class SoulfileApiError {
  constructor(public type: SoulfileApiErrorTypes, public error: Error) {}
}
